import React from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import {
  Card,
  Modal,
  Icon,
  Segment,
  Form,
  Button,
  Label,
} from "semantic-ui-react"
import bind from "bind-decorator"
import { withTranslation } from "react-i18next"

@withTranslation()
@withRouter
export default class StoreCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editedData: props.createStore ? {} : false,
      deleteClicked: false,
      errorText: "requiredField",
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.stores && this.props.stores) {
  //     if (this.props.stores.length === 1) {
  //     }
  //   }
  // }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onChange({}, { value, name, data }) {
    if (value.length < 3) {
      this.setState({
        error: true,
      })
    } else {
      this.setState({
        error: false,
      })
    }
    this.setState({
      editedData: {
        ...this.state.editedData,
        [name]: value,
        id: data,
      },
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onSelectStore({}, { data }) {
    const { selectStore, history } = this.props
    selectStore(data)
    history.push("/cashbox")
  }

  @bind
  onBekzhan(id) {
    const { selectStore, history } = this.props
    selectStore(id)
    // history.push("/cashbox")
  }

  @bind
  selectStoreAfterCreating(id) {
    this.props.selectStore(id)
  }

  @bind
  startEditing() {
    const { name, address } = this.props
    this.setState({
      editedData: {
        name,
        address,
      },
    })
  }

  @bind
  cancelEditing() {
    this.setState({
      editedData: false,
      deleteClicked: false,
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onDelete({}, { data }) {
    const { deleteStore } = this.props
    deleteStore(data)
  }

  @bind
  onModal() {
    this.setState({
      deleteClicked: !this.state.deleteClicked,
    })
  }

  @bind
  onSave() {
    const { editStore } = this.props
    const { editedData } = this.state
    if (!editedData.name) {
      this.setState({
        errorInputName: true,
      })
    } else {
      this.setState({
        errorInputName: false,
      })
    }
    if (!editedData.address) {
      this.setState({
        errorInputAddr: true,
      })
    } else {
      this.setState({
        errorInputAddr: false,
      })
    }
    if (editedData.name && editedData.address) {
      editStore(editedData)
      this.cancelEditing()
    }
  }

  @bind
  onCreate() {
    const { createStore, cancelCreating } = this.props
    const { editedData } = this.state
    if (!editedData.name) {
      this.setState({
        errorInputName: true,
      })
    } else {
      this.setState({
        errorInputName: false,
      })
    }
    if (!editedData.address) {
      this.setState({
        errorInputAddr: true,
      })
    } else {
      this.setState({
        errorInputAddr: false,
      })
    }
    if (editedData.name && editedData.address) {
      createStore(editedData)
      cancelCreating()
    }
    // this.selectStoreAfterCreating(id)
    // return <Redirect to="/cashbox" />
  }

  renderEditingData() {
    const {
      editedData: { address, name },
      deleteClicked,
      errorInputName,
      errorInputAddr,
      errorText,
    } = this.state
    const { createStore, cancelCreating, id, t } = this.props
    return [
      <Card.Content key="1">
        <Form>
          <Form.Input
            label={t("storeName")}
            name="name"
            value={name || ""}
            data={id}
            error={errorInputName}
            onChange={this.onChange}
          />
          {errorInputName && (
            <Label basic color="red" pointing>
              {t(errorText)}
            </Label>
          )}
          <Form.Input
            label={t("storeAddress")}
            name="address"
            data={id}
            error={errorInputAddr}
            value={address || ""}
            onChange={this.onChange}
          />
          {errorInputAddr && (
            <Label basic color="red" pointing>
              {t(errorText)}
            </Label>
          )}
          <p style={{ fontSize: "13px", marginTop: "-15px" }}>
            *{" "}
            {t(
              "The address must match the address issued during registration with the tax authority",
            )}
          </p>
        </Form>
      </Card.Content>,
      createStore ? (
        <Card.Content key="2" extra>
          <Button color="green" onClick={this.onCreate}>
            {t("create")}
          </Button>
          <Button basic onClick={cancelCreating}>
            {t("cancel")}
          </Button>
        </Card.Content>
      ) : (
        <Card.Content key="2" extra>
          <Button color="green" onClick={this.onSave}>
            {t("save")}
          </Button>
          <Button basic onClick={this.cancelEditing}>
            {t("cancel")}
          </Button>
          <Button basic color="red" onClick={this.onModal}>
            {t("delete")}
          </Button>
          {deleteClicked && (
            <Modal open size="mini" style={{ position: "fixed", top: "40%" }}>
              <Modal.Content>{t("confirmDelete")}</Modal.Content>
              <Modal.Actions>
                <Button color="red" onClick={this.onModal}>
                  <Icon name="remove" /> {t("no")}
                </Button>
                <Button color="green" data={id} onClick={this.onDelete}>
                  <Icon name="checkmark" /> {t("yes")}
                </Button>
              </Modal.Actions>
            </Modal>
          )}
        </Card.Content>
      ),
    ]
  }

  renderData() {
    const { name, address, id, stores, currentStore, t } = this.props
    if (stores) {
      if (stores.length === 1 && currentStore === undefined) {
        this.onBekzhan(stores[0].id)
      }
    }
    return (
      <>
        <Card.Content>
          <Card.Header>{name}</Card.Header>
          <Card.Meta>{address}</Card.Meta>
        </Card.Content>
        <Card.Content extra>
          <div className="ui two buttons">
            <Button
              basic
              color="green"
              onClick={this.onSelectStore}
              content={t("select")}
              data={id}
            />
            <Button basic color="grey" onClick={this.startEditing}>
              {t("change")}
            </Button>
          </div>
        </Card.Content>
      </>
    )
  }

  render() {
    const { t } = this.props
    const { editedData } = this.state
    const { isLoading } = this.props
    return (
      <Card t={t} as={Segment} loading={isLoading} style={{ width: "100%" }}>
        {editedData ? this.renderEditingData() : this.renderData()}
      </Card>
    )
  }
}

StoreCard.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.string,
  isLoading: PropTypes.bool,
  deleteStore: PropTypes.func,
  editStore: PropTypes.func,
  createStore: PropTypes.func,
  cancelCreating: PropTypes.func,
}
